import { useState } from 'react';
import { useToast } from '../../providers/ToastProvider';
import axios, { AxiosError } from 'axios';
import { ToastType } from '../../ui/components/Toast';
import { translate } from '../../types/translation/Translator';
import { TranslationKey } from '../../types/translation/TranslationKey';

export function useRequest<V, R>(
  fn: (payload: V) => Promise<R>,
  onError?: (error: AxiosError<any>, message: string) => void,
): [(payload: V) => Promise<R | undefined>, { loading: boolean }] {
  const { showToast } = useToast();

  const [loading, setLoading] = useState(false);

  async function execute(payload: V): Promise<R | undefined> {
    setLoading(true);

    try {
      return await fn(payload);
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.error || translate({ key: TranslationKey.somethingUnexpectedHappened });
        if (onError) {
          onError(error, message);
        } else {
          showToast({ type: ToastType.error, title: message });
        }
      } else {
        showToast({ type: ToastType.error, title: translate({ key: TranslationKey.somethingUnexpectedHappened }) });
      }
    } finally {
      setLoading(false);
    }
  }

  return [execute, { loading }];
}
